module.exports = __webpack_public_path__ + "img/orav_3kl.d54d45d0.jpg";